// src/data/lynLevels.js
// Single source of truth for the Learn-Your-Notes GAME levels — used by both
// the falling-note game (LynGame.jsx) and the Note Trail map (LynMap.jsx).
//
// Mirrors the 3-part Learn-Your-Notes journey:
//   L1 = C · D · E    L2 = F · G    L3 = Note A (building the first line of Twinkle)
// Every level shows the SAME white-key octave (C4–B4) so the keyboard always
// looks familiar; only the notes that FALL change per level.
//
// VIDEO: the "how to find your notes" clip only exists for CDE, so only Level 1
// carries a videoFile + autoVideo. F & G and Note A have no video yet.

const LEARN_VIDEO = "Learn Your Notes.mp4";

export const LEVELS = {
  1: {
    id: 1,
    order: 1,
    building: "Melody Cottage",
    icon: "🏠",
    blurb: "Learn C · D · E",
    accent: "#10B981",
    title: "Learn Your Notes — C · D · E",
    notes: ["C", "D", "E"],
    firstKey: "C4",
    lastKey: "B4",
    fallSeconds: 7.5,
    videoFile: LEARN_VIDEO, // how-to-find-notes intro (CDE only)
    autoVideo: true,        // auto-play on entry
    prompts: [
      ["C", "C", "C"],
      ["C", "D"],
      ["D", "D", "D"],
      ["C", "D", "D"],
      ["D", "C", "D"],
      ["C", "D", "E"],
      ["E", "E"],
      ["D", "E"],
      ["C", "E", "D", "E"],
      ["E", "D", "C", "E", "D", "C"],
    ],
    panIntro: "Treble Town's magic is fading! 🐼",
    wisIntro: "Play each falling note and we'll bring the magic back! 🦉",
  },

  2: {
    id: 2,
    order: 2,
    building: "Harmony Hall",
    icon: "🏛️",
    blurb: "Learn F & G",
    accent: "#3B82F6",
    title: "Learn Your Notes — F & G",
    notes: ["F", "G"],
    firstKey: "C4",
    lastKey: "B4",
    fallSeconds: 7,
    // no video yet for F & G
    prompts: [
      ["F", "F", "F"],
      ["F", "G"],
      ["G", "G", "G"],
      ["F", "G", "G"],
      ["G", "F", "G"],
      ["E", "F", "G"],
      ["F", "G", "E"],
      ["C", "E", "G"],
      ["G", "F", "E", "D"],
      ["C", "D", "E", "F", "G"],
    ],
    panIntro: "Two new notes to wake up Harmony Hall! 🐼",
    wisIntro: "F is just right of E, and G is its next-door neighbour! 🦉",
  },

  3: {
    id: 3,
    order: 3,
    building: "Twinkle Tower",
    icon: "🗼",
    blurb: "Note A + Twinkle",
    accent: "#EC4899",
    title: "Learn Your Notes — Note A",
    notes: ["A"],
    firstKey: "C4",
    lastKey: "B4",
    fallSeconds: 7,
    // no video yet for Note A
    prompts: [
      ["A", "A", "A"],
      ["G", "A"],
      ["A", "A", "G"],
      ["C", "C"],
      ["C", "C", "G", "G"],
      ["A", "A", "G"],
      ["C", "A", "G"],
      ["C", "C", "G", "G", "A"],
      ["A", "A", "G", "G"],
      ["C", "C", "G", "G", "A", "A", "G"],
    ],
    panIntro: "Note A lights the top of Twinkle Tower! 🐼",
    wisIntro: "Learn A and you can play the start of Twinkle Twinkle! 🦉",
  },
};

export const LEVEL_ORDER = [1, 2, 3];

// The next playable level after `id`, or null if none.
export function nextPlayableLevel(id) {
  const i = LEVEL_ORDER.indexOf(Number(id));
  for (let j = i + 1; j < LEVEL_ORDER.length; j++) {
    const lv = LEVELS[LEVEL_ORDER[j]];
    if (lv && !lv.comingSoon) return lv.id;
  }
  return null;
}